module.exports = __webpack_public_path__ + "static/media/edit.c9ac3c41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.svg
// module id = 256
// module chunks = 0